export default __webpack_public_path__ + "static/media/Citizen_Logo_Black.694f2951.png";